import React, { Fragment, useState } from "react";
import { Col, Form, Row, Button, Card, ProgressBar } from "react-bootstrap";
import { CCArticleResult, ReEntryAssessmentCertification, ReEntryAssessmentResult } from "../Models/Assessment";
import { ArticleResultList } from "../ContinuingCertification/Components/ArticleResultList";
import ReEntryAssessmentCertificationCard from "./ReEntryAssessmentCertificationCard";

interface IProps {
    assessment: ReEntryAssessmentResult;
}

export function ReEntryAssessmentCard(props: IProps) {

const [detailVisible, setDetailVisible] = useState<boolean>(false);

const getTotalPassed = () => {
    var totalPassed = 0;
    if (props.assessment.reEntryAssessmentCertifications.length > 0){
        for (var i = 0; i < props.assessment.reEntryAssessmentCertifications.length; i++){
            if (props.assessment.reEntryAssessmentCertifications[i].ccArticleResults.length > 0)
            {
                for (var a = 0; a < props.assessment.reEntryAssessmentCertifications[i].ccArticleResults.length; a++)
                {
                    if (props.assessment.reEntryAssessmentCertifications[i].ccArticleResults[a].isPass)
                    {
                        totalPassed++;
                    }
                }
            }    
        }
    }

    return totalPassed;
}

const getTotalFailed = () => {
    var totalFailed = 0;
    if (props.assessment.reEntryAssessmentCertifications){
        for (var i = 0; i < props.assessment.reEntryAssessmentCertifications.length; i++){
            if (props.assessment.reEntryAssessmentCertifications[i].ccArticleResults)
            {
                for (var a = 0; a < props.assessment.reEntryAssessmentCertifications[i].ccArticleResults.length; a++)
                {
                    if (!props.assessment.reEntryAssessmentCertifications[i].ccArticleResults[a].isPass)
                    {
                        totalFailed++;
                    }
                }
            }    
        }
    }

    return totalFailed;
}

const failureMax = props.assessment.attemmtpsAllowed - props.assessment.totalArticleRequirement;

const percentPassed = getTotalPassed() / props.assessment.totalArticleRequirement * 100;
const percentFailed = getTotalFailed() / failureMax * 100;
const totalAttempts = getTotalPassed() + getTotalFailed();

const getStatusMessage = () => {
    if (getTotalFailed() > failureMax){
        return "You have exceeded the number of failed article exams allowed. Unfortunately, you were unsuccessful with the article exams. You will need to apply/pay for, and pass, the traditional CC/recertification exam in order to maintain your certification.";
    }
    else if (getTotalPassed() < props.assessment.totalArticleRequirement){
        return `You have passed ${getTotalPassed()} of ${props.assessment.totalArticleRequirement} article exams needed to pass with ${totalAttempts - getTotalFailed() - getTotalPassed()} article exams remaining.`
    }
    else {
        return `Congratulations!  You have passed ${getTotalPassed()} of ${props.assessment.totalArticleRequirement} article exams needed to pass.`
    }
}


    const articleResultsExist = () => {
        return getAllArticleResults().length > 0
    }

    const getAllArticleResults = () => {
        var allArticleResults = Array<CCArticleResult>();
        props.assessment.reEntryAssessmentCertifications.map((reEntryAssessmentCertification: ReEntryAssessmentCertification) => {
            reEntryAssessmentCertification.ccArticleResults && reEntryAssessmentCertification.ccArticleResults.map((ccArticleResult: CCArticleResult) => {
                allArticleResults.push(ccArticleResult);
            })
        })

        return allArticleResults;
    }


    return(
        <Fragment>
            <Row className="align-items-end">
                <Col>
                    <Form.Group controlId="dueDate">
                        <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Article Exams Due By</Form.Label>
                        <Form.Text>{props.assessment.endYear}</Form.Text>                    
                    </Form.Group>
                </Col>
            </Row>
            <Row noGutters className="align-items-end">
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">&nbsp;</Form.Label> 
                    </Col>
                    <Col className="text-center col-4">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Passed</Form.Label> 
                    </Col>
                    <Col className="text-center col-4">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Failed</Form.Label> 
                    </Col>
                    <Col className="text-center col-2">
                        <Form.Label className="mb-0 font-weight-bold pp-font-size-smaller">Total Attempts</Form.Label> 
                    </Col>
                </Row>
            {props.assessment.reEntryAssessmentCertifications?.length > 1 && props.assessment.reEntryAssessmentCertifications?.map((reEntryAssessmentCertification: ReEntryAssessmentCertification) => {                
                    return <ReEntryAssessmentCertificationCard 
                        reEntryAssessmentCertification={reEntryAssessmentCertification} 
                        perCertificationArticleRequirement={props.assessment.perCertificationArticleRequirement} />})
            }
            
            <Row noGutters className="align-items-center mb-0">
                <Col className="text-left col-2">
                    <Form.Label className="mb-0 pp-font-size-smaller">{props.assessment.reEntryAssessmentCertifications?.length > 1 ? "Total" : props.assessment.reEntryAssessmentCertifications[0].certificationName}</Form.Label> 
                </Col>
                <Col className="col-4 text-right" style={{height: "26px" }}>
                    <Form.Group controlId="articleProgress">
                        <div className="d-flex flex-row ">
                            <div className="w-75 mb-1 mt-1">
                                <ProgressBar variant="pp-secondary" role="progressbar" now={percentPassed} max={100} ></ProgressBar>
                            </div>
                            <Form.Text className="ml-1">{getTotalPassed()}/{props.assessment.totalArticleRequirement}</Form.Text>        
                        </div>                  
                    </Form.Group>
                </Col>
                <Col className="col-4 text-right" style={{height: "26px" }}>
                    <Form.Group controlId="articleProgress">
                        <div className="d-flex flex-row ">
                            <div className="w-75 mb-1 mt-1">
                                <ProgressBar variant="pp-secondary" role="progressbar" now={percentFailed} max={100} ></ProgressBar>
                            </div>
                            <Form.Text className="ml-1">{getTotalFailed()}/{failureMax}</Form.Text>        
                        </div>                  
                    </Form.Group>
                </Col>
                <Col className="text-center col-2">
                    <Form.Label className="mb-0 pp-font-size-smaller">{totalAttempts}/{props.assessment.attemmtpsAllowed}</Form.Label> 
                </Col>
            </Row>
            <Row noGutters>
                <Col className="text-center col-11">
                    <Form.Label className="font-weight-bolder mt-2 pp-font-size-smaller">{getStatusMessage()}</Form.Label>
                </Col>
            </Row>
            { detailVisible &&
                <Row>
                    <ArticleResultList articleResults={getAllArticleResults()}/>
                </Row>
            }
            <Card bsPrefix="border-0 pp-align-self-end mt-2">
                <a href="https://moc.abpn.com" target="_blank"><Button variant="pp-primary" className="mb-3 mr-1">Access Article Exams<i className="ml-1 las la-external-link-alt"></i></Button></a>
                { articleResultsExist() && <Button className="mb-3" variant="outline-pp-primary" onClick={() => setDetailVisible(!detailVisible)}>{detailVisible ? "Hide" : "Show"} Detail</Button>}
            </Card>
            <div className="pp-font-size-smallest">* Clicking 'Access Article Exams' will navigate you to the article portal</div>
            <hr className="mt-0"/>
        </Fragment>
    );
}

export default ReEntryAssessmentCard;